/** Kurzer Hinweiston per Web Audio (keine Audiodatei nötig). Browser erlauben Ton erst nach einer Nutzeraktion. */
let ctx: AudioContext | null = null;

export function chime(kind: "info" | "urgent" = "info") {
  try {
    ctx ??= new AudioContext();
    const now = ctx.currentTime;
    const notes = kind === "urgent" ? [880, 660, 880] : [660, 880];
    notes.forEach((f, i) => {
      const o = ctx!.createOscillator();
      const g = ctx!.createGain();
      o.frequency.value = f;
      o.type = "sine";
      g.gain.setValueAtTime(0.0001, now + i * 0.18);
      g.gain.exponentialRampToValueAtTime(0.25, now + i * 0.18 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.18 + 0.16);
      o.connect(g).connect(ctx!.destination);
      o.start(now + i * 0.18);
      o.stop(now + i * 0.18 + 0.17);
    });
  } catch {
    /* ohne Audio weiter */
  }
}

/** Browser geben Ton erst nach einer Nutzeraktion frei – Status und Freigabe */
export const audioReady = () => ctx?.state === "running";
export async function unlockAudio() {
  try {
    ctx ??= new AudioContext();
    await ctx.resume();
  } catch {
    /* ohne Audio weiter */
  }
  return audioReady();
}
